import { useQuery } from 'react-query';
import { useSession } from 'common/hooks';
import { FeaturesEnum } from 'features/feature-access/features.enum';
import { useFeatureAccess } from 'features/feature-access/hooks/useFeatureAccess';
import { matchingEngineApi } from '../matching-engine.utils';

export const useCanViewProfileActivities = (profileId?: string) => {
  const { account: user } = useSession();
  const { canRead: hasActivitiesAccess } = useFeatureAccess(FeaturesEnum.ACTIVITIES);

  const { data, isLoading } = useQuery(
    ['matching-engine', user?.organizationId, profileId, 'activity-access'],
    () => matchingEngineApi.get(`profiles/${profileId}/activity-access`),
    {
      enabled: !!profileId && hasActivitiesAccess,
      refetchOnWindowFocus: false,
    },
  );

  return {
    canViewActivities: hasActivitiesAccess && !!data?.data?.canViewActivities,
    isLoading: hasActivitiesAccess && isLoading,
  };
};
